<table class="zc-validation-table">
    <thead>
        <td class="group-cell header-cell">Group</td>
        <td class="sub-group-cell header-cell">Sub-group</td>
        <td class="category-cell header-cell">Category</td>
        <td class="field-cell header-cell">Field</td>
        <td class="error-cell header-cell">Error</td>
    </thead>
    <tbody>
        <tr *ngFor="let validationData of data">
            <td class="group-cell">{{validationData.group}}</td>
            <td class="sub-group-cell">{{validationData.subGroup}}</td>
            <td class="category-cell">{{validationData.category}}</td>
            <td class="field-cell">{{validationData.field}}</td>
            <td class="error-cell">{{validationData.error}}</td>
        </tr>
    </tbody>
</table>
